import Vue from 'vue';

const state = {
    items: [],
};

const mutations = {
    changeOfficesParams(state, items) {
        state = Object.assign(state, items)
    }
};

const getters = {
    getOfficesItems: (state, getters) => {
        let items = state.items.filter(item => {
            if (item.city === getters.getUserCity.value || item.city === 0)
                return item;
        });
        return items;
    }
};

const actions = {
    setOfficesItems({ commit }) {
        commit('createProcess', 'offices');
        Vue.http.get(this.getters.getApiUrl + 'v1/offices?filter[active]=1&sort=sort,-date_create&per-page=1000').then(response => {
            commit('changeOfficesParams', { items: response.data });
            commit('setProcessSuccess', 'offices');
        }, response => {
            commit('setProcessFailed', { id: 'offices', message: response.body.message });
        });
    }
};

export default {
    state,
    getters,
    actions,
    mutations,
}


// WEBPACK FOOTER //
// ./src/store/modules/offices.js